import { setTheme } from './index'

export const themes = {
  light: {
    name: 'LIGHT', bg: '#F2F2F2', bgElevated: '#F8F8F8', bgSidebar: '#F5F5F5',
    text: '#0A0A0A', textSecondary: '#555555', textMuted: '#888888',
    border: '#D8D8D8', borderStrong: '#C8C8C8',
    primary: '#00F5D4', primaryDim: 'rgba(0,245,212,0.08)',
    accent: '#7B2FFF', accentDim: 'rgba(123,47,255,0.08)',
    cardBg: '#F8F8F8', sidebarBg: '#F5F5F5', topbarBg: 'rgba(242,242,242,0.95)',
    inputBg: '#EEEEEE', hoverBg: 'rgba(0,245,212,0.05)',
    navActiveBg: 'rgba(0,245,212,0.10)', navActiveBorder: '#00F5D4',
    shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  },
  dark: {
    name: 'DARK', bg: '#1A1A1A', bgElevated: '#222222', bgSidebar: '#1E1E1E',
    text: '#FAFAFA', textSecondary: '#A0A0A0', textMuted: '#606060',
    border: '#2A2A2A', borderStrong: '#3A3A3A',
    primary: '#00F5D4', primaryDim: 'rgba(0,245,212,0.12)',
    accent: '#A855F7', accentDim: 'rgba(168,85,247,0.12)',
    cardBg: '#222222', sidebarBg: '#1E1E1E', topbarBg: 'rgba(30,30,30,0.95)',
    inputBg: '#252525', hoverBg: 'rgba(0,245,212,0.08)',
    navActiveBg: 'rgba(0,245,212,0.12)', navActiveBorder: '#00F5D4',
    shadow: '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)',
  },
}

export type ThemeName = 'light' | 'dark'
export type ThemeVars = typeof themes.light

export function getVars(theme: ThemeName): ThemeVars {
  return themes[theme]
}

export function toggleTheme(): ThemeName {
  const next = (localStorage.getItem('teslacam_theme') === 'dark') ? 'light' : 'dark'
  setTheme(next)
  return next
}
